// AppRoutes: public and authenticated user routes setup
import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import HomePage from "../pages/HomePage";
import ToursPage from "../pages/ToursPage";
import TourDetailsPage from "../pages/TourDetailsPage";
import BookingPage from "../pages/BookingPage";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import ProfilePage from "../pages/ProfilePage";
import UserBookingsPage from "../pages/UserBookingsPage";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminLayout from "../layouts/AdminLayout";
import AdminDashboard from "../pages/AdminDashboard";
import BookingSuccess from "../pages/BookingSuccess";
import BookingCancel from "../pages/BookingCancel";
import BookingReserved from "../pages/BookingReserved";
import BookingConfirmPage from "../pages/BookingConfirmPage";
import NotFoundPage from "../pages/NotFoundPage";

export default function AppRoutes() {
  return (
    <Routes>
      {/* 👇 Routes publiques avec MainLayout */}
      <Route element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="/tours" element={<ToursPage />} />
        <Route path="/tours/:id" element={<TourDetailsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Payment/Booking result pages */}
        <Route path="/booking/success" element={<BookingSuccess />} />
        <Route path="/booking/cancel" element={<BookingCancel />} />
        <Route path="/booking/reserved" element={<BookingReserved />} />

        {/* Protected user routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/confirm" element={<BookingConfirmPage />} />
          <Route path="/my-bookings" element={<UserBookingsPage />} />
        </Route>
      </Route>

      {/* 👇 Routes admin HORS de MainLayout */}
      <Route element={<ProtectedRoute role="admin" />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="tours" element={<AdminDashboard section="tours" />} />
          <Route path="users" element={<AdminDashboard section="users" />} />
          <Route
            path="bookings"
            element={<AdminDashboard section="bookings" />}
          />
          <Route
            path="reviews"
            element={<AdminDashboard section="reviews" />}
          />
          <Route
            path="messages"
            element={<AdminDashboard section="messages" />}
          />
          <Route
            path="settings"
            element={<AdminDashboard section="settings" />}
          />
        </Route>
      </Route>

      {/* 404 Not Found */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
